/* import __COLOCATED_TEMPLATE__ from './playlist.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class PlayqueuePlaylistComponent extends Component {
  @service currentlyPlaying;

  @action
  removePlaylist(event) {
    console.log('removePlaylist', event);
    event.preventDefault();
    this.currentlyPlaying.removePlaylist(this.args.playlist);
  }

  @action
  removePlaylistEntry(playlistEntry) {
    console.log('removePlaylistEntry', playlistEntry, this.args.playlist);
    this.args.playlist.playlistEntries.removeObject(playlistEntry);
    this.currentlyPlaying.removeBounce(playlistEntry.bounce);
  }
}
